function _(e,s,n){const o=e(413);n.Tables=o,e(6).register_models(o)}
//# sourceMappingURL=main.min.js.map